import React from "react";
import SetdataProvider from "../context/SetdataContext";
import FormResume from "./FormResume";

function SetResume() {
    
    return(
            <div className="resumeForm">
                <FormResume />
            </div>
    )
}

export default SetResume